module.exports = {
  line_items: [
    {
      lead_times: [1, 2, 3],
      pricing   : [
        [0, 0, 0],
        [0, 0, 0],
        [0, 0, 0],
        [0, 0, 0],
      ],
      quantities      : [10, 25, 50, 100],
      product_key     : 'fabrication-tw-offshore-jet-pcb',
      quote_config_key: 'fabrication-tw-offshore-jet-pcb',
    },
  ],
};
